module.exports = __webpack_public_path__ + "img/logo-underside.05544fdd.png";